import webDeveloperImg from 'public/asset/product/pulsar/05-AVIF/web-developer@2x.png';
import webDesignerImg from 'public/asset/product/pulsar/05-AVIF/web-designer@2x.png';
import developer from 'public/asset/product/pulsar/05-AVIF/just-developer@2x.png';

type Content = {
  img_src: string;
  t: string;
  t_desc: string;
  desc: string;
};

export const en: Content[] = [
  {
    img_src: webDeveloperImg.src,
    t: 'Web Developer',
    t_desc: 'Image Conversion API Document',
    desc: 'When image conversion is required to speed up the loading of the web/app service screen, or when image optimization and conversion functions are required within the web/app service.',
  },
  {
    img_src: webDesignerImg.src,
    t: 'Web Designer',
    t_desc: 'Image Converting Web・App Service',
    desc: 'When you need an image with a small file size while maintaining the high quality of the original image.',
  },
  {
    img_src: developer.src,
    t: 'Developer',
    t_desc: 'SDK Installation with Accelerating System',
    desc: 'When you need a modular/installable image optimization and transformation development kit that for local server-based applications equipped with FPGA accelerator cards.',
  },
];

export const ko: Content[] = [
  {
    img_src: webDeveloperImg.src,
    t: '웹개발자',
    t_desc: '이미지 변환 API 도큐먼트 제공',
    desc: '웹・앱 서비스 화면의 로딩 속도를 빠르게 하기 위한 이미지 변환이 필요한 경우 또는 웹・앱 서비스 내에서 이미지 최적화 및 변환 기능이 필요한 경우',
  },
  {
    img_src: webDesignerImg.src,
    t: '웹디자이너',
    t_desc: '이미지 변환 웹・앱 서비스 제공',
    desc: '원본의 선명한 화질은 유지하고 작은 용량의 이미지가 필요한 경우',
  },
  {
    img_src: developer.src,
    t: '개발자',
    t_desc: '가속 처리 기능이 포함된 설치형 SDK 제공',
    desc: 'FPGA 가속 카드가 장착된 로컬 서버 기반의 애플리케이션에 적용할 수 있는 모듈형・설치형 이미지 최적화 및 변환 개발킷이 필요한 경우',
  },
];
